import { asyncRouterMap, constantRouterMap } from '@/router/index';

// 从 ums_menu 同步标题、图标、可见性与排序（sort 越大越靠前）
function applyMenuMeta(route, menus) {
  if (!route.name) {
    route.sort = route.sort != null ? route.sort : 0;
    return;
  }
  const currMenu = getMenu(route.name, menus);
  if (currMenu != null) {
    if (currMenu.title != null && currMenu.title !== '') {
      route.meta.title = currMenu.title;
    }
    if (currMenu.icon != null && currMenu.icon !== '') {
      route.meta.icon = currMenu.icon;
    }
    if (currMenu.hidden != null) {
      route.hidden = currMenu.hidden !== 0;
    }
    if (currMenu.sort != null && currMenu.sort !== '') {
      route.sort = currMenu.sort;
    } else {
      route.sort = route.sort != null ? route.sort : 0;
    }
    return;
  }
  if (route.hidden !== undefined && route.hidden === true) {
    route.sort = -1;
  } else {
    route.sort = route.sort != null ? route.sort : 0;
  }
}

//判断是否有权限访问该菜单
function hasPermission(menus, route) {
  if (route.name) {
    const currMenu = getMenu(route.name, menus);
    if (currMenu != null) {
      applyMenuMeta(route, menus);
      return true;
    }
    if (route.hidden !== undefined && route.hidden === true) {
      applyMenuMeta(route, menus);
      return true;
    }
    return false;
  }
  return true;
}

//根据路由名称获取菜单（支持扁平列表与树形 children）
function getMenu(name, menus) {
  if (!menus || menus.length === 0) {
    return null;
  }
  for (let i = 0; i < menus.length; i++) {
    let menu = menus[i];
    if (name === menu.name) {
      return menu;
    }
    if (menu.children && menu.children.length > 0) {
      let childMenu = getMenu(name, menu.children);
      if (childMenu != null) {
        return childMenu;
      }
    }
  }
  return null;
}

//对菜单进行排序
function sortRouters(accessedRouters) {
  for (let i = 0; i < accessedRouters.length; i++) {
    let router = accessedRouters[i];
    if(router.children && router.children.length > 0){
      router.children.sort(compare("sort"));
    }
  }
  accessedRouters.sort(compare("sort"));
}

//降序比较函数
function compare(p){
  return function(m,n){
    let a = m[p];
    let b = n[p];
    return b - a;
  }
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data;
        const { username } = data;
        const accessedRouters = asyncRouterMap.filter(v => {
          // admin 账号展示全部菜单，便于联调（生产环境可按需关闭）
          if (username === 'admin') {
            applyMenuMeta(v, menus);
            if (v.children && v.children.length > 0) {
              v.children.forEach(child => applyMenuMeta(child, menus));
            }
            return true;
          }
          if (hasPermission(menus, v)) {
            if (v.children && v.children.length > 0) {
              v.children = v.children.filter(child => {
                if (hasPermission(menus, child)) {
                  return child
                }
                return false;
              });
              return v
            } else {
              return v
            }
          }
          return false;
        });
        //对菜单进行排序
        sortRouters(accessedRouters);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      })
    }
  }
};

export default permission;




// WEBPACK FOOTER //
// ./src/store/modules/permission.js